export const MAX_DATE = new Date(9999, 12, 31)
